module.exports = {
	backend: {
		url: "https://api-b.mirrads.de", // On migration change this url
		devUrl: "https://api-dev.mirrads.de", // Do not change
		qualityUrl: "https://api-q.mirrads.de", // Do not change
		liveClusterA: "https://api.mirrads.de", // Do not change
		liveClusterB: "https://api-b.mirrads.de" // Do not change
	},
	update: {
		url: 'https://update.mirrads.de'	
	},
	frontend: {
		url: 'https://cms-b.mirrads.de', // On migration change this url
		version: '0.8.0'
	}
}